/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { motion } from 'framer-motion';

export const DEFAULT_TRANSITION = { ease: [0.75, 0.02, 0.5, 1], duration: 0.5 };

export const AnimatedContainer: React.FC<any> = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={DEFAULT_TRANSITION}
      data-test-id="animated-container-component"
    >
      {children}
    </motion.div>
  );
};

export default AnimatedContainer;
